<template>
  <div>
    <div class="user_body">
      <span class="title">订单详情</span>
      <span class="order_id">订单号:{{ orderInfo.order_no }}</span>
      <div class="line"></div>
      <span class="status">{{orderInfo.statusText}}</span>
      <div class="status_bar">
        <div class="status_outer_bar"></div>
        <div class="status_inner_bar">
          <div
            :class="item.flag==1?'status_inner_bar_div1':'status_inner_bar_div2'"
            v-for="(item,index) in status"
            :key="index"
          >{{item.title}}</div>
        </div>
        <div class="time">
          <div
            v-for="(item,index) in status"
            :key="index"
            :class="item.flag==1?'time_content1':'time_content2'"
            
          >{{item.time}}</div>
        </div>
      </div>
      <div class="product_info" v-for="(item,index) in orderInfo.goods_info" :key="index">
        <img src="@/assets/user_icon1.png">
        <div class="goods-title" style="flex:2">
          <div >{{item.title}}</div>
          <div v-if="item.sku_name">{{item.sku_name}}</div>
        </div>
        <span style="flex:1">{{item.price}}元 X {{item.total}}</span>
        <span>{{item.price*item.total}}元</span>
      </div>
      <div class="line"></div>
      <div class="address">
        <span class="address_1">收货信息</span>
        <span class="add_text2">配送方式：{{orderInfo.delivery_method}}</span>
        <span class="add_text2">收货信息：{{orderInfo.delivery_username}} {{orderInfo.delivery_mobile}} {{orderInfo.delivery_province + orderInfo.delivery_city + orderInfo.delivery_area + orderInfo.delivery_address}}</span>
      </div>
      <div class="line"></div>
      <div class="address" v-for="(express,index) in orderInfo.express" :key="index">
        <span class="address_1">快递信息</span>
        <span class="add_text2">快递公司:{{express.express_name}}</span>
        <div class="da">
          <span class="add_text2">物流单号: {{express.express_no}}</span>
          <span class="add_text2" style="color:#3C9C8F;margin-left: 10px;cursor: pointer;" @click="checkDelivery(express)"> 物流查询</span>
        </div>
      </div>
       <div class="line"></div>
       <div class="prices">
           <div class="prices_1">
               <span>商品总价：</span>
               <span>{{ orderInfo.original_price }}元</span>
           </div>
            <div class="prices_1">
               <span>运费：</span>
               <span>{{ orderInfo.express_fee }}元</span>
           </div>
            <div class="prices_2">
               <span>应付金额：</span>
               <span>{{ orderInfo.total_price }}元</span>
           </div>
       </div>
    </div>
    <orderDelivery :id="orderInfo.id" :dialog-visible="dialogDeliveryVisible" :orderInfo="orderInfo" :row="rowData" @closeDialog="closeDialogDelivery" />
  </div>
</template>

<script>
import orderDelivery from './componets/orderDelivery.vue'
import { mapGetters } from 'vuex'
export default {
  name: "MyOrderInfoView",
  components: {
    orderDelivery
  },
  computed: {
    ...mapGetters(['base'])
  },
  data() {
    return {
      orderInfo:{},
      dialogDeliveryVisible: false,
      rowData: {},
      status: [
        {
          title: "下单",
          time: "2024-10-10 12:12:12",
          flag: "1"
        },
        {
          title: "确认",
          time: "2024-10-10 12:12:12",
          flag: "1"
        },
        {
          title: "发货",
          time: "2024-10-10 12:12:12",
          flag: "1"
        },
        {
          title: "完成",
          time: "2024-10-10 12:12:12",
          flag: "1"
        }
      ]
    };
  },
  mounted() {
    this.getOrderInfo();
  },
  methods: {
    // 查看物流
    checkDelivery(row) {
      if(this.base.data.aliyun_delivery.status != 1){
					return this.$message.error('平台未开启物流查询')
				}
       
      this.dialogDeliveryVisible = true
      this.rowData = row
    },
    closeDialogDelivery() {
      this.dialogDeliveryVisible = false
    },
    getOrderInfo(){
      this.$api.getOrderDetail({
        id: this.$route.query.id
      }).then(res => {
        console.log(res);
        if(res.code == 1){
          this.orderInfo = res.data;
          switch(this.orderInfo.status){
            case 0:
              this.status[0].flag = 1;
              this.status[1].flag = 2;
              this.status[2].flag = 2;
              this.status[3].flag = 2;
              break;
            case 1:
              this.status[0].flag = 1;
              this.status[1].flag = 1;
              this.status[2].flag = 2;
              this.status[3].flag = 2;
              break;
            case 2:
              this.status[0].flag = 1;
              this.status[1].flag = 1;
              this.status[2].flag = 1;
              this.status[3].flag = 2;
              break;
            case 3:
            this.status[0].flag = 1;
              this.status[1].flag = 1;
              this.status[2].flag = 1;
              this.status[3].flag = 1;
              break;
          }
        }else{
          this.$message.error(res.message);
        }
      }).catch(err => {
        console.log(err);
      });
    }
  }
};
</script> 

<style lang="less"  scoped>
.user_body {
  background: #ffffff;
  padding: 25px;
  display: flex;
  flex-direction: column;
}
.title {
  color: #666666;
  font-size: 16px;
}
.order_id {
  color: #000000;
  font-size: 14px;
  line-height: 20px;
  margin-top: 40px;
}
.line {
  height: 1px;
  background: #f1f1f1;
  margin-top: 15px;
  margin-bottom: 15px;
}
.status {
  color: #999999;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 16px;
  line-height: 28px;
}
.status_outer_bar {
  height: 20px;
  background: #f1f1f1;
  border-radius: 20px;
  margin-left: 20px;
  margin-right: 20px;
  position: absolute;
}
.status_inner_bar {
  height: 20px;
  margin-left: 20px;
  margin-right: 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.status_inner_bar :first-child {
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
}
.status_inner_bar :last-child {
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}
.status_inner_bar_div1 {
  height: 20px;
  background: #83c44e;
  flex: 1;
  color: #ffffff;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
}
.status_inner_bar_div2 {
  height: 20px;
  background: #f1f1f1;
  flex: 1;
  color: #666666;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
}
.time {
  margin-left: 20px;
  margin-right: 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
}
.time_content1 {
  color: #666666;
  font-size: 12px;
  text-align: center;
  flex: 1;
}
.time_content2 {
  color: #666666;
  font-size: 12px;
  text-align: center;
  flex: 1;
  visibility: hidden;
}
.product_info {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #000000;
  font-size: 14px;
}
.product_info img {
  width: 80px;
  height: 80px;
}
.address {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.address_1{
  color: #000000;
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 20px;
}
.add_text2 {
  color: #666666;
  font-size: 14px;
  margin-bottom: 10px;
}
.da {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  color: #666666;
  font-size: 14px;
  align-items: center;
}
.prices{
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
}
.prices_1{
      display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-end;
    margin-bottom: 10px;
}
.prices_1 span:nth-child(odd){
    width: 100px;
    color: #333333;
    font-size: 14px;
    text-align: right;
}
.prices_1 span:nth-child(even){
    width: 100px;
    color: #3C9C8F;
    font-size: 14px;
      text-align: right;
}
.prices_2{
      display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-end;
    margin-bottom: 10px;
}
.prices_2 span:nth-child(odd){
    // width: 100px;
    color: #333333;
    font-size: 14px;
    text-align: right;
}
.prices_2 span:nth-child(even){
    // width: 100px;
    color: #3C9C8F;
    font-size: 24px;
      text-align: right;
}
</style>
  



